import { __assign, __makeTemplateObject, __rest } from "tslib";
import MuiTableContainer from '@material-ui/core/TableContainer';
import React, { forwardRef } from 'react';
import { styled, useThemeProps } from '../../../foundation';
import { TableContainerStyle } from './styles';
var _RcTableContainer = forwardRef(function (props, ref) {
    var _a = useThemeProps({
        props: props,
        name: 'RcTableContainer',
    }), children = _a.children, bordered = _a.bordered, square = _a.square, rest = __rest(_a, ["children", "bordered", "square"]);
    return (React.createElement(MuiTableContainer, __assign({}, rest, { ref: ref }), children));
});
var RcTableContainer = styled(_RcTableContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TableContainerStyle);
RcTableContainer.defaultProps = {
    bordered: false,
    square: false,
};
RcTableContainer.displayName = 'RcTableContainer';
export { RcTableContainer };
var templateObject_1;
